import React from 'react'
import { Card, Row, Col, Container } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive'
import credito from 'src/assets/tcredito.webp'
import yappy from 'src/assets/yappy.webp'
import clave from 'src/assets/clave.webp'

const FormaPagoCard = ({
    selectPago,
    onChangeSelectPago,
    // redirectPagoBG
}) => {

    const isMobile = useMediaQuery({ maxWidth: 768 });

    const formasPagos = [
        {
            title: 'Tarjeta de crédito',
            idOrigen: parseFloat(process.env.REACT_APP_ID_ORIGEN_TARJETA_CREDITO),
            imagen: credito,
            styleCard: {
                width: isMobile ? '100%' : '15rem',
                height: isMobile ? '7rem' : '7.5rem'
            },
            styleImg: {
                maxWidth: '100%',
                width: '11rem',
                height: 'auto'
            },
            redirect: false // se agrega este params redirect por problema del api del proveedor de pasarela de pago
        },
        {
            title: 'Yappy',
            idOrigen: parseFloat(process.env.REACT_APP_ID_ORIGEN_YAPPY),
            imagen: yappy,
            styleCard: {
                width: isMobile ? '100%' : '15rem',
                height: isMobile ? '7rem' : '7.5rem'
            },
            styleImg: {
                maxWidth: '100%',
                paddingTop: 14,
                width: '12rem',
                height: 'auto'
            },
            redirect: false // se agrega este params redirect por problema del api del proveedor de pasarela de pago
        },
        {
            title: 'Clave',
            idOrigen: parseFloat(process.env.REACT_APP_ID_ORIGEN_CLAVE),
            imagen: clave,
            styleCard: {
                width: isMobile ? '100%' : '15rem',
                height: isMobile ? '7rem' : '7.5rem'
            },
            styleImg: {
                maxWidth: '100%',
                width: '11rem',
                paddingTop: 0,
                height: 'auto'
            },
            redirect: false // se agrega este params redirect por problema del api del proveedor de pasarela de pago
        }
    ]

    return (
        <Container>
            <Row>
                {
                    formasPagos.map(({ title, idOrigen, imagen, styleCard, styleImg, redirect = false }) => (
                        <Col key={idOrigen} md={4} lg={4} className='py-2'>
                            <p className='text-center form-text' style={{ fontSize: '13px' }}>{title}</p>
                            <Card
                                className={`shadow border-radius ${selectPago === idOrigen ? 'select-card' : ''} `}
                                style={styleCard}
                                onClick={() => {
                                    if (!redirect) {
                                        onChangeSelectPago(idOrigen)

                                    } else {
                                        window.open("https://clickpago.merchantprocess.net/clientv2/client/FEDPA", "_blank");
                                    }
                                }}
                            >
                                <Card.Body>
                                    <div className='text-center'>
                                        <Card.Img
                                            src={imagen}
                                            alt='forma de pago'
                                            crossOrigin='anonymous'
                                            variant="bottom"
                                            style={styleImg}
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))
                }
            </Row>
        </Container>
    )
}

export default FormaPagoCard